import React, { useCallback } from 'react'
import CruisePriceRoomTypeInfo from './CruisePriceRoomTypeInfo'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import { CruiseContentSections } from 'constants/cruise'
import Group from 'components/utils/Group'

interface Props {
  onView: (ref: string) => void
  offer: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  hasValidDepartures?: boolean
  visible: boolean
}

function CruiseStickyFooter(props: Props) {
  const { onView, priceFrom, visible, hasValidDepartures, offer } = props

  const onCTAClick = useCallback(() => onView(CruiseContentSections.DEPARTURES), [onView])

  return (
    <OfferPageStickyFooter
      visible={visible}
      callToActionCopy="Check Availability"
      onCTAClick={onCTAClick}
      callToActionDisabled={!hasValidDepartures}
    >
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" tabletGap={16}>
        <CruisePriceRoomTypeInfo priceFrom={priceFrom} hasValidDepartures={hasValidDepartures} offer={offer} />
      </Group>
    </OfferPageStickyFooter>
  )
}
export default CruiseStickyFooter
